<template>
  <img
    :alt="`${$t.brand} ${$t.home}`"
    class="forced-colors:prefer-dark:invert forced-colors:prefer-light:invert-0"
    :class="{ invert }"
    data-test-id="vf-logo"
    height="45"
    :src="`${'/img/logos/thenorthface/default.svg'}`"
    width="97"
  >
</template>

<script lang="ts" setup>
defineProps<{
  invert?: boolean
}>()
</script>
